export default "__VITE_ASSET__BJg7DVQD__"